import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

interface LoadingSpinnerProps {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
  color?: string;
  fullScreen?: boolean;
  text?: string;
}

export function LoadingSpinner({
  className,
  size = "md",
  color,
  fullScreen = false,
  text
}: LoadingSpinnerProps) {
  // Size mappings
  const sizeMap = {
    sm: "h-4 w-4",
    md: "h-8 w-8",
    lg: "h-12 w-12",
    xl: "h-16 w-16"
  };

  // Color mapping
  const colorClass = color || "text-primary";
  
  const spinner = (
    <div className={cn("flex flex-col items-center justify-center", className)}>
      <Loader2 className={cn("animate-spin", sizeMap[size], colorClass)} />
      
      {text && (
        <p className={cn("mt-3 text-sm font-medium", colorClass)}>
          {text}
        </p>
      )}
    </div>
  );
  
  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white bg-opacity-80 z-50 flex items-center justify-center">
        {spinner}
      </div>
    );
  }
  
  return (
    <div className="flex items-center justify-center py-8">
      {spinner}
    </div>
  );
}
